import * as React from 'react';
import { HighlightedContentItem, HighlightedContent } from '@grandvisionhq/content';
import { compose } from '@grandvisionhq/utils';
import { withAnchor } from '../../hocs/with-anchor.js';
import '@swc/helpers';
import '@bloomreach/react-sdk';
import '../../context/configuration.js';
import '@bloomreach/spa-sdk';
import '@grandvisionhq/search';
import 'jsonpointer';
import '@grandvisionhq/common';
import '../../utils/http-client.js';
import { parseBloomreachImage } from '../../utils/parse-bloomreach-image.js';
import '@grandvisionhq/state';
import { useBloomreachLinks } from '../../hooks/use-bloomreach-links.js';
import '@grandvisionhq/lib-utils-html';
import '@grandvisionhq/graphql';
import '../../operations/mutations/signup-promotion.js';
import '../../operations/mutations/subscribe-newsletter.js';
import '../../operations/mutations/subscribe-newsletter-opt-in.js';
import '@grandvisionhq/svc-tealium/events';
import '../../hooks/use-breakpoint-visibility.js';
import { withBloomreachPageable } from '../../hocs/with-bloomreach-pageable.js';
import { withBreakpointVisibility } from '../../hocs/with-breakpoint-visibility.js';
import { withEditableContent } from '../../hocs/with-editable-content.js';
import { withHidableContent } from '../../hocs/with-hidable-content.js';

const CmsBlogCollectionItem = withEditableContent(({ content  })=>{
    const { title , summary , url  } = content;
    const coverImage = parseBloomreachImage(content.coverImage);
    const [link] = useBloomreachLinks([
        {
            url: url !== null && url !== void 0 ? url : '#'
        }
    ]);
    if (!coverImage) {
        return null;
    }
    return /*#__PURE__*/ React.createElement(HighlightedContentItem, {
        image: coverImage.original,
        title: title,
        text: summary,
        link: link
    });
});
const CmsBlogCollection = ({ content  })=>/*#__PURE__*/ React.createElement(HighlightedContent, null, content.items.map((item)=>/*#__PURE__*/ React.createElement(CmsBlogCollectionItem, {
            key: item.id,
            content: item
        })
    ))
;
var BlogCollection = compose(withBreakpointVisibility, withHidableContent, withBloomreachPageable, withAnchor)(CmsBlogCollection);

export { CmsBlogCollection, CmsBlogCollectionItem, BlogCollection as default };
//# sourceMappingURL=BlogCollection.js.map
